module.exports = {
  "blogSearch.categories.title": "CATEGORÍAS",
  "blogSearch.results.title": "RESULTADOS",
  "blogSearch.results.fullResults": "VER TODOS LOS RESULTADOS",
  "blogSearch.noResults": "No encontramos resultados para tu búsqueda 🔍"
}
